import api from "./api";

const getDimenionValues = (search) => {
  // If a lookupFilter lf1: string is provided, embed it at the end of the
  // filter param using "||" as a separator so it survives the single
  // query-param path to the Go handler. The server detects and extracts it.
  const { lookupFilter, ...rest } = search;
  const filter = rest.filter || "";
  const params = lookupFilter
    ? { ...rest, filter: filter + "||" + lookupFilter }
    : rest;

  return api.get("/dimensions",{
    params
  })
  .then((response) => {
    return response.data;
  });
};





const DimensionSevice = {
  getDimenionValues,
};

export default DimensionSevice;